// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".VideoGallery[data-v-18987696]{width:100%;height:100%;position:absolute;display:flex;justify-content:center;align-items:center;z-index:1;background:rgba(0,0,0,.82)}.vg-container[data-v-18987696]{position:absolute;margin-top:30px;background:#fff;border-radius:10px;transition:width .4s ease,height .4s ease}.vg-video[data-v-18987696]{margin-top:40px;width:90%;max-height:85%;border-radius:0 0 10px 10px}", ""]);
// Exports
module.exports = exports;
